import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import fr from "./fr.json";
import enProfile from "./en/profile.json";
import frProfile from "./fr/profile.json";
import enExperience from "./en/experience.json";
import frExperience from "./fr/experience.json";
import enAssociative from "./en/associative.json";
import frAssociative from "./fr/associative.json";
import enContact from "./en/contact.json";
import frContact from "./fr/contact.json";
import enInterests from "./en/interests.json";
import frInterests from "./fr/interests.json";
import enEducation from "./en/education.json";
import frEducation from "./fr/education.json";
import enProjects from "./en/projects.json";
import frProjects from "./fr/projects.json";
import enSkills from "./en/skills.json";
import frSkills from "./fr/skills.json";
import enTestimonials from "./en/testimonials.json";
import frTestimonials from "./fr/testimonials.json";
import frCertifications from "./fr/certifications.json";
import enCertifications from "./en/certifications.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
      profile: enProfile,
      experience: enExperience,
      testimonials: enTestimonials,
      skills: enSkills,
      projects: enProjects,
      education: enEducation,
      interests: enInterests,
      contact: enContact,
      associative: enAssociative,
      certifications: enCertifications,
    },
    fr: {
      translation: fr,
      profile: frProfile,
      experience: frExperience,
      testimonials: frTestimonials,
      skills: frSkills,
      projects: frProjects,
      education: frEducation,
      interests: frInterests,
      contact: frContact,
      associative: frAssociative,
      certifications: frCertifications,
    },
  },
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
